/**
 * This file is in desperate need of a refactor. However it's also
 * slated to be replaced soon so we're just going to leave it
 * untouched until it dies.
 */
(function () {
  window.Home = window.Home || {};

  //Reset function for testing purposes
  function reset() {
  }

  function getPersonSectionUrl(activity, person) {
    if (activity.type === 'SOURCE') {
      return "/tree/person/sources/" + person.id;
    }
    return "/tree/person/memories/" + person.id;
  }

  function getLifeSpanMeta(lifeSpan) {
    if (typeof lifeSpan !== "string") {
      return {
        textKey: '',
        birthYear: NaN,
        deathYear: NaN
      }
    }
    const formattedLifeSpan = lifeSpan.toLowerCase();

    var parts = formattedLifeSpan.split('-'),
      birthYear = parseInt(parts[0], 10),
      deathYear = parseInt(parts[1], 10),
      deceased = formattedLifeSpan.indexOf("deceased") != -1 || (!isNaN(birthYear) && isNaN(deathYear)),
      living = formattedLifeSpan.indexOf("living") != -1
      ;

    var textKey;
    if (living) {
      if (isNaN(birthYear)) {
        textKey = 'lifeSpanLiving';
      } else {
        textKey = 'lifeSpanBirthAndLiving';
      }
    } else if (deceased) {
      if (isNaN(birthYear)) {
        textKey = 'lifeSpanDeceased';
      } else {
        textKey = 'lifeSpanBirthAndDeceased';
      }
    } else if (!isNaN(birthYear) && !isNaN(deathYear)) {
      textKey = 'lifeSpan';
    }
    return {
      textKey: textKey || '',
      birthYear: birthYear,
      deathYear: deathYear
    }
  }

  function checkSingleOrMultipleTimePassed(timePassed, singleLocaleKey, multipleLocaleKey) {
    if (Math.floor(timePassed) == 1) {
      return singleLocaleKey;
    }
    return multipleLocaleKey;
  }

  function getElapsedTimeMeta(time) {
    if (time && time.replace) {
      time = time.replace(/\+0000/g, "Z"); // time format fix for Safari - replace no offset with UTC
    }
    var date = new Date(time);
    if (isNaN(date.getTime())) {
      console.log('time not valid: ', time);
      return '';
    }

    var localeKey = "daysAgo";
    var today = new Date();
    var oneDay = 24 * 60 * 60 * 1000; // How many miliseconds in a day

    // Filter first by days for performance reasons
    var timePassed = Math.floor(Math.abs((today.getTime() - date.getTime()) / oneDay)); // How many days have passed
    if (timePassed == 0) {
      timePassed = Math.round(Math.abs((date.getTime() - today.getTime()) / 1000)); // Seconds passed
      if (timePassed > 59) {
        timePassed = Math.floor(timePassed / 60); // Minutes passed
        if (timePassed > 59) {
          timePassed = Math.floor(timePassed / 60); // Hours passed
          localeKey = checkSingleOrMultipleTimePassed(timePassed, "aboutAnHourAgo", "hoursAgo");
        } else {
          if (Math.floor(timePassed) == 1) {
            localeKey = "aboutAMinuteAgo";
          } else if (Math.floor(timePassed) <= 3) {
            localeKey = "aFewMinutesAgo";
          } else {
            localeKey = "minutesAgo";
          }
        }
      }
      else {
        localeKey = checkSingleOrMultipleTimePassed(timePassed, "secondAgo", "secondsAgo");
      }
    }
    else {
      if (timePassed > 29) {
        timePassed = Math.floor(timePassed / 30); // Months passed
        if (timePassed > 11) {
          timePassed = Math.floor(timePassed / 12); // Years passed
          localeKey = checkSingleOrMultipleTimePassed(timePassed, "yearAgo", "yearsAgo");
        } else {
          localeKey = checkSingleOrMultipleTimePassed(timePassed, "monthAgo", "monthsAgo");
        }
      }
      else {
        localeKey = checkSingleOrMultipleTimePassed(timePassed, "dayAgo", "daysAgo");
      }
    }

    return {
      textKey: localeKey,
      elapsedTime: timePassed
    };
  }

  Home.Alerts = {
    getPersonSectionUrl: getPersonSectionUrl,
    getLifeSpanMeta: getLifeSpanMeta,
    getElapsedTimeMeta: getElapsedTimeMeta,
    reset: reset
  };

}());
